import MODULE from "@/flit2go-web-core/interfaces/moduleConstants";
import {
  CONTROL_MAP,
  CONTROL_MAP_OWNERS,
  GEOFENCE_FORM,
  GEOFENCES_LIST,
} from "@/modules/Control/routesInterface.js";
import store from "@/flit2go-web-core/store/index";

const menu = {
  code: MODULE.CONTROL.CODE,
  name: "control",
  label: "common.control",
  link: CONTROL_MAP,
  children: [],
  createChildren: [],
};

const submenus = [
  {
    code: MODULE.CONTROL.MAP,
    name: "control",
    label: "common.map",
    link: CONTROL_MAP,
  },
  {
    code: MODULE.CONTROL.GEOFENCE,
    label: "common.geofences",
    link: GEOFENCES_LIST,
    name: "geofences",
  },
];

const submenusCreate = [
  {
    code: MODULE.CONTROL.GEOFENCE,
    label: "Geofence",
    link: GEOFENCE_FORM,
    name: "geofence",
  },
];

function getMenu(submodules) {
  const isSuperOwner = store.getters["auth/isSuperOwner"];
  checkSuperOwnerMenu(isSuperOwner);

  menu.children = [];
  menu.createChildren = [];
  submodules.forEach((submodule) => {
    const submenuAux = submenus.find(
      (submenu) => submenu.code === submodule.code
    );
    const submenuCreateAux = submenusCreate.find(
      (submenu) => submenu.code === submodule.code
    );
    if (submenuAux && (submodule.r || submodule.w)) {
      menu.children.push(submenuAux);
    }
    if (submenuCreateAux && submodule.w) {
      menu.createChildren.push(submenuCreateAux);
    }
  });
  return menu;
}

function checkSuperOwnerMenu(isSuperOwner) {
  submenus[0].link = isSuperOwner ? CONTROL_MAP_OWNERS : CONTROL_MAP;
}

export default { getMenu };
